import React from 'react';

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-gray-50">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-[#fabddf] border-t-[#2d2f4e] rounded-full animate-spin"></div>
        <div className="mt-4 text-center text-[#2d2f4e]">Loading...</div>
      </div>
    </div>
  );
}; 